

/* ---------------------------------- SP Menu toggle ---------------------------------- */

$('[name=spMenuToggle]').on('click', function (e){
  e.preventDefault();
  $('[name=spMenuToggle]').toggleClass("active");
  $("#headerSpMenuWrap").fadeToggle(300);
  //スクロールさせない制御
  if($(this).hasClass("active")){
    $("html,body").css("overflow","hidden");
    //フッターメニューの「探す」を押した場合はその他のメニューを非表示
    if( $(this).data("menu-search") ){
      $("#headerSpMenuOthers").hide();
    }else{
      $("#headerSpMenuOthers").show();
    }
  }else{
    $("html,body").css("overflow","auto");
  }
});

$('.header_sp_menu_list_title').on('click', function (e){
  e.preventDefault();
  $(this).toggleClass("active");
  $(this).next(".header_sp_menu_list").slideToggle();
});

/* ----------------------- Category Select Slide Toggle ----------------------- */

$('.cmn_cate_select_title_switch').on('click', function (e){
  e.preventDefault();
  if($(this).hasClass("active")){
    $(this).removeClass("active");
  }else{
    $(this).addClass("active");
  }
  $(this).next().slideToggle();
});

/* ------------------------------ お気に入り関連 ------------------------------ */

var favListData = getFavoriteLocalStorage();
//console.log(JSON.stringify(favListData));
function getFavoriteLocalStorage(){
  var favListObj = localStorage.getItem('favList');
  //console.log("お気に入りリストJSON: "+jsonObj);
  if(favListObj){
    return JSON.parse(favListObj);
  }else{
    return {};
  }
}
//お気に入り登録件数
var favListCount = Object.keys(favListData).length;
$('#header-fav-count').text(favListCount);

//お気に入り登録済みの場合はボタンを登録済み表示に
activateFavoritedIcon();
//非同期で出す場所も割りとあるので window on load 後にも実行
$(window).on("load", function () {
  activateFavoritedIcon();
});
function activateFavoritedIcon(){
  favListData = getFavoriteLocalStorage();
  favListCount = Object.keys(favListData).length;
  $('[name="fav-count"]').text(favListCount);
  if(favListCount > 0){
    $('[name="add-to-fav"]').each(function(i, elm) {
      var thisItemId = $(elm).data("item-id");
      if(favListData[thisItemId]){
        $(elm).addClass("active");
      }
    });
  }
}

//ボタンクリックでお気に入り登録・解除
$(document).on('click', '[name="add-to-fav"]', function(){
  favListData = getFavoriteLocalStorage();
  var itemId = $(this).data("item-id");
  if(!$(this).hasClass("active")){
    var itemName = $(this).data("item-name");
    var itemPrice = $(this).data("item-price");
    var itemUrl = $(this).data("item-url");
    var itemImage = $(this).data("item-image");
    var itemCreated = new Date().getTime();
    var thisData = { name: itemName, price: itemPrice, url: itemUrl, image: itemImage, created: itemCreated};
    favListData[itemId] = thisData;
    var addData = JSON.stringify(favListData);
    //console.log(SaveData);
    localStorage.setItem('favList', addData);
    $(this).addClass("active");
  }else{
    delete favListData[itemId];
    var delData = JSON.stringify(favListData);
    //console.log(SaveData);
    localStorage.setItem('favList', delData);
    $(this).removeClass("active");
    $('[name="add-to-fav"][data-item-id="' + itemId + '"]').removeClass("active");
  }
  favListCount = Object.keys(favListData).length;
  $('[name="fav-count"]').text(favListCount);
  activateFavoritedIcon();
});
//ボタンクリックでお気に入り解除（ひとまずお気に入りリストページでのみ）
$('#favoriteList').on('click', '[name="del-fav"]', function(){
  favListData = getFavoriteLocalStorage();
  var itemId = $(this).data("item-id");
  delete favListData[itemId];
  var delData = JSON.stringify(favListData);
  localStorage.setItem('favList', delData);
  favListCount = Object.keys(favListData).length;
  $('[name="fav-count"]').text(favListCount);
  makeFavList();
});

//お気に入りリストページの場合だけ、リスト生成
var urlPath = location.pathname;
if ( urlPath.indexOf('/pages/favorite') != -1) {
  makeFavList();
}

function makeFavList(){
  if(!favListCount){
    $('#favListNoItemMsg').show();
  }
  var favListHtml = '';
  $.each(favListData, function(key, item) {
    //console.log(key + ': ' + item);
    let dispDate = ( new Date(item.created) ).toLocaleDateString();

    favListHtml += '<li>';
    favListHtml += '<a href="' + item.url + '">';
    favListHtml += '<div class="fav_list_image" style="background-image:url(' + item.image + ');"></div>';
    favListHtml += '</a>';
    favListHtml += '<div class="fav_list_info">';
    favListHtml += '<button class="fav_list_del" name="del-fav"  data-item-id="' + key + '"></button>';
    favListHtml += '<a href="' + item.url + '">';
    favListHtml += '<h3 class="fav_list_name">' + item.name + '</h3>';
    favListHtml += '<p class="fav_list_price">' + item.price + '</p>';
    favListHtml += '</a>';
    favListHtml += '</div>';
    /* バリエーション特定出来ないのでトリとのこと
    favListHtml += '<form method="post" action="/cart/add" class="fav_list_add_to_cart" accept-charset="UTF-8" enctype="multipart/form-data" novalidate="novalidate" data-product-form="">';
    favListHtml += '<input type="hidden" name="form_type" value="product"><input type="hidden" name="utf8" value="✓">';
    favListHtml += '<input type="hidden" name="id" value="' + key + '">';
    favListHtml += '<button type="submit" name="add">カートに入れる</button>';
    favListHtml += '</form>';
    */
    favListHtml += '</li>';

  })
  $("#favoriteList").html(favListHtml);
}


